// src/lib/api/prerequisiteApi.ts

import { getApiClient } from './client';
import {
    NeedPrerequisite,
    PrerequisiteStatus,
    SetPrerequisitesRequest,
} from '../models/prerequisite';

const getPrerequisites = async (needId: string): Promise<NeedPrerequisite[]> => {
    try {
        const data = await getApiClient().get<{ prerequisites: NeedPrerequisite[] }>(`/api/needs/${needId}/prerequisites`);
        return data.prerequisites || [];
    } catch {
        return [];
    }
};

const getPrerequisiteStatus = async (needId: string): Promise<PrerequisiteStatus> => {
    return await getApiClient().get<PrerequisiteStatus>(`/api/needs/${needId}/prerequisites/status`);
};

const setPrerequisites = async (needId: string, data: SetPrerequisitesRequest): Promise<void> => {
    await getApiClient().post(`/api/needs/${needId}/prerequisites`, data);
};

// ── Course-based application prerequisites (#217) ────────────────────
export interface NeedRequiredModule {
    id: string;
    need_id: string;
    module_id: string;
    min_score?: number;
    sort_order: number;
}

export interface RequiredModuleCheck {
    module_id: string;
    module_name: string;
    completed: boolean;
    met: boolean;
}

export interface RequiredModulesStatus {
    all_met: boolean;
    total: number;
    completed: number;
    modules: RequiredModuleCheck[];
}

export interface SetRequiredModulesRequest {
    required_modules: { module_id: string; min_score?: number }[];
}

const getRequiredModules = async (needId: string): Promise<NeedRequiredModule[]> => {
    try {
        const data = await getApiClient().get<{ required_modules: NeedRequiredModule[] }>(`/api/needs/${needId}/required-modules`);
        return data.required_modules || [];
    } catch {
        return [];
    }
};

const getRequiredModulesStatus = async (needId: string): Promise<RequiredModulesStatus> => {
    return await getApiClient().get<RequiredModulesStatus>(`/api/needs/${needId}/required-modules/status`);
};

const setRequiredModules = async (needId: string, data: SetRequiredModulesRequest): Promise<void> => {
    await getApiClient().post(`/api/needs/${needId}/required-modules`, data);
};

export const prerequisiteApi = {
    getPrerequisites,
    getPrerequisiteStatus,
    setPrerequisites,
    getRequiredModules,
    getRequiredModulesStatus,
    setRequiredModules,
};
